<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <w-input style="margin:5px; " v-model="pencarian.tarikh_mohon" type="date" label="Tarikh Mohon"/>
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis_id" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;RESET</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
              <w-icon class="mr2">fal fa-cog</w-icon>
              {{dialog.title}}
            </template>
             <w-form ref="form" 
               v-model:errors-count="form.errorsCount"
               v-model="dialog.valid"
               @validate="simpan"
               @success="success" 
               >
         
                <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                    <w-flex wrap :gap="2">
                       <div class="grow mb4" style="min-width: 200px">
                          <w-input class="mt4" label="Tarikh Temu Janji Penilaian *" type="date" v-model="form.tarikh_temujanji" :validators="[validators.required]"/>
                          <w-select class="mt4" :items="penilai" label="Nama Pegawai Penilaian *"  v-model="form.penilai_id"  :validators="[validators.required]"/>
                        </div>
                    </w-flex>
                 </div>
              </div>
           </w-form>
            <template #actions>
              <div class="spacer" />
              <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
               <w-button 
                  class="ml1" 
                  :loading="dialog.loading"
                  v-if="dialog.loading===false"
                  :disabled="dialog.valid === false"
                  @click="$refs.form.validate()"
                  >

                    SIMPAN
                  </w-button>
                  <w-button 
                  class="ml1" 
                  :loading="dialog.loading"
                  v-if="dialog.loading===true"
                  disabled
                  @click="$refs.form.validate()"
                  >
                    SIMPAN
                  </w-button>
           </template>
         </w-dialog>
         <w-dialog
          v-model="dialog_juruteknik.show"
          :fullscreen="dialog_juruteknik.fullscreen"
          width="900"
          :persistent="dialog_juruteknik.persistent"
          :persistent-no-animation="dialog_juruteknik.persistentNoAnimation"
          title-class="primary-dark1--bg white">
            <template #title>
                  <w-icon class="mr2">fal fa-exchange</w-icon>
                  Tukar Penyelaras STPP Negeri
            </template>
         
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>TARIKH / MASA MOHON</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.tarikh_mohon}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>NO. PERMOHONAN</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.no_permohonan}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>PENTERNAK / NO TELEFON</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.nama_premis}} / {{dialog_form.no_tel_premis}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID PREMIS / NAMA PREMIS</b></td>
                     <td><b> : </b></td>
                     <td>{{dialog_form.premis}}</td>
                  </tr>
                  </tbody>
               </table>
            </div>
            </div>
            &nbsp;
            <span style="color: red"><h2> **Sila hubungi Penternak & Penyelaras STPP Negeri sebelum membuat pertukaran</h2></span>
            &nbsp;
            <w-form 
            ref="form" 
            v-model="dialog_juruteknik.valid"
            @validate="tukarPemeriksa(dialog_form, dialog_form.id)"
            @success="success"
            >
               <w-select class="mt4" outline :items="pemeriksa" label="Nama Pemeriksa *"  v-model="dialog_form.pemeriksa_id"  :validators="[validators.required]"/>
            <w-textarea class="mt4" label="Catatan *" v-model="dialog_form.catatan" :validators="[validators.required]" outline />
         </w-form>

          
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_juruteknik.show = false">TUTUP</w-button>
            <w-button 
            class="ml1" 
            :loading="dialog_juruteknik.loading"
            :disabled="dialog_juruteknik.valid === false"
            @click="$refs.form.validate()"
            >
              SIMPAN
            </w-button>
         </template>

          
        </w-dialog>
  		  <z-table title="Senarai Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <template #button v-if="$zutil.role('2') || $zutil.role('1') || $zutil.role('5')">
                <w-button dark class="green--bg ml1" :route="$route('pdbf.permohonan.form',0)" >
                    <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
                </w-button>
            </template>
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
  		    <template #item-cell.action="{ item, label, header, index }">
  		      <w-flex class="flex justify-center">
              <w-tooltip md top align-left color="white" bg-color="black" >
                <template #activator="{ on }">
                  <w-button  bg-color="info" v-on="on"  v-if="item.lkp_status_id !=18 && item.lkp_status_id == 21 && $zutil.anyRole(['1', '2', '5'])" :route="$route('pdbf.permohonan.form',0)+'?salin='+item.id" class="be fs-2"><div style="width: 8px"></div>
                    <w-icon md class="mr2">fal fa-copy</w-icon>
                  </w-button>
                </template>
                Salin
              </w-tooltip>
                &nbsp;
              <w-tooltip top color="white" bg-color="black">
                 <template #activator="{ on }">
                    <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id !=31 && item.lkp_status_id !=32 && item.lkp_status_id !=18 && item.lkp_status_id !=35 && $zutil.anyRole(['1', '2', '5'])" :route="$route('pdbf.permohonan.form',item.id)" class="be fs-2"><div style="width: 8px"></div>
                    <w-icon md class="mr2">fal fa-pencil</w-icon>
                    </w-button>
                  </template>
                  Kemaskini
                </w-tooltip>
                &nbsp;
                <w-tooltip top color="white" bg-color="black">
                 <template #activator="{ on }">
                     <w-button class="fs-2" v-on="on" v-if="item.lkp_status_id == 19 && $zutil.anyRole(['1', '2', '5'])" bg-color="error-dark1" dark tile @click="destroy1(item.id)"><div style="width: 8px"></div>
                <w-icon md class="mr2">fal fa-trash</w-icon> 
                </w-button>
                  </template>
                  Padam
                </w-tooltip>
            &nbsp;
              <template v-if="item.lkp_status_id==31">
              <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                 <w-button class="mr2" v-on="on" bg-color="success" v-if=" $zutil.anyRole(['4'])" @click="add(item)"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-check-circle</w-icon>
                 </w-button>
               </template>
               Terima
            </w-tooltip> &nbsp;
             <br>
              <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <w-button class="mr2" v-on="on" bg-color="error" v-if=" $zutil.anyRole(['4'])" @click="onSuccess(2, item.id)"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-times-circle</w-icon>
                    </w-button>
                </template>
               Tolak
            </w-tooltip>
            &nbsp;
            <w-tooltip md top color="white" bg-color="black" >
                  <template #activator="{ on }">
                     <w-button class="mr2" v-on="on" bg-color="warning" v-if=" $zutil.anyRole(['4'])" @click="Tukar(item, 3)"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-exchange</w-icon>
                     </w-button>
                  </template>
                  Tukar Pemeriksa
               </w-tooltip> &nbsp;
              <br>
          </template>
               <w-tooltip md top align-right color="white" bg-color="black">
                 <template #activator="{ on }">
                    <!-- <inertia-link :href="$route('pdbf.penilaian.index',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link> -->
                    <w-button class="mr2" v-on="on" bg-color="primary" @click="getPenilaian(item)"><div style="width: 8px"></div>
                       <w-icon md class="mr2">fal fa-eye</w-icon>
                    </w-button>
                  </template>
                  Papar
                </w-tooltip>
  		      </w-flex>
  		    </template>

  		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'pdbf.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Penilaian Daya Biak & Fertiliti', route: '/pdbf' },
        { label: 'Permohonan', route: '/pdbf/permohonan' },
      ],
      title : 'Pdbf Permohonan',
      form : this.d_form,
      
      
      pencarian: {
         premis_id: '',
         tarikh_mohon: '',
         lkp_status_id: '',
      },
      premis: [],
      premis_id: [],
      tarikh: [],
      lkp_status :[],
      penilai:[],
      dialog_juruteknik: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      
      
    }
  },
  methods: {
    Tukar(item, tindakan){
      //tindakan '3' untuk tukar juruteknik
      //tindakan '2' untuk Padam
       this.dialog_form = {
           id : item.id,
           pemeriksa_id : item.pemeriksa_id,
           catatan : null,
           tindakan : tindakan,
           tarikh_mohon : item.tarikh_mohon,
           no_permohonan : item.no_permohonan,
           nama_premis : item.nama_premis,
           no_tel_premis : item.no_tel_premis,
           nama_pemohon : item.nama_pemohon,
           no_tel_pemohon : item.no_tel_pemohon,
           premis : item.premis,
       }
       this.getPemeriksa(item)
       this.dialog_juruteknik.show = true;
   },

    getPenilaian(item){
      window.location.href = window.route('pdbf.penilaian.index')+'?pdbf_id='+item.id;
      // window.open( window.route('pdbf.penilaian.index',));
    },
     add(item){
          this.form = {
              id : item.id,
              penilai_id : '',
              tarikh_temujanji : '',
              

          }
          
          this.dialog.show = true
          this.dialog.title = 'Tarikh Temu Janji Penilaian '
          this.form.saveButton = "Simpan"
      },

   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    tukarPemeriksa(tindakan, pdbf_id){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (pdbf_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', pdbf_id, tindakan)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                  this.$zutil.notify("Berjaya ditukar", true);
                this.$inertia.visit(this.$route(this.resourceurl+'.index'))
              })
            }
          }
        })
      
    },

     destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {
        this.lkp_status = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },

   getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

    getPenilai(){
         this.$zcomm.get(this.api_service + 'lookup/pemeriksa', {}).then(res => {
           this.penilai = res
         })
       },

    getPemeriksa(){
         this.$zcomm.get(this.api_service + 'lookup/pemeriksa', {}).then(res => {
           this.pemeriksa = res
         })
       },

    simpan(){
         this.dialog.loading = true
         if(this.dialog.valid == true){
            if (this.form.id > 0) 
            {
              this.form.terima = 1
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
               this.$inertia.visit(route(route().current()));
               this.dialog.loading = false
               this.dialog.show = false
                // this.loading = 0;
              })
            }
            
         }else{
            this.dialog.loading = false
         }
       },


    onSuccess(tindakan, pdbf_id){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (pdbf_id > 0){
              this.$zcomm.update(this.resourceurl + '.tindakan', pdbf_id, {tindakan :tindakan})
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.$inertia.visit(this.$route(this.resourceurl+'.index'))
              })
            }
          }
        })
      
    },
    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();
   this.getPenilai();
   this.getPremisCarian();
   this.getPemeriksa();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
